import { isValidFileSignature as stringCheckIsValidFileSignature, SUPPORTED_MIME_TYPES } from '@connect-x-app/shared-utils';

export const isValidFileMimeType = async (file: File): Promise<boolean> => {
  if (!SUPPORTED_MIME_TYPES.map(entry => entry.mimeType).includes(file.type)) {
    return false;
  }

  return await isValidFileSignature(file);
};

const getFileHeader = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = e => {
      if (!e.target?.result) {
        return reject(new Error('Failed to read file'));
      }
      const arrayBuffer = e.target.result as ArrayBuffer;
      const uint8Array = new Uint8Array(arrayBuffer).subarray(0, 12); // Read first 12 bytes
      const header = Array.from(uint8Array)
        .map(byte => byte.toString(16).padStart(2, '0'))
        .join('')
        .toUpperCase();
      resolve(header);
    };
    reader.onerror = () => reject(new Error('Error reading file'));
    reader.readAsArrayBuffer(file.slice(0, 12)); // Read first 12 bytes
  });
};

const isValidFileSignature = async (file: File): Promise<boolean> => {
  return stringCheckIsValidFileSignature(await getFileHeader(file), file.type);
};
